module.exports = __webpack_public_path__ + "img/adolph.d40b22be.jpg";